import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  //   change to element type
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.elementType.isRequired,
  className: PropTypes.string,
}

const defaultProps = {
  title: '',
  className: '',
}

function GenericCard({ icon, title, description, className }) {
  return (
    <div className={className}>
      {icon}
      <h2>
        <b>{title}</b>
      </h2>
      {description}
    </div>
  )
}

GenericCard.propTypes = propTypes
GenericCard.defaultProps = defaultProps

export default GenericCard
